import {ObjectID} from "../driver/mongodb/typings";

export type EntityId = string|number|Date|ObjectID;